// Generated by purs version 0.15.0
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_EuclideanRing from "../Data.EuclideanRing/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Map from "../Data.Map/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ratio from "../Data.Ratio/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Restaumatic_Menu_V2_Packaging from "../Restaumatic.Menu.V2.Packaging/index.js";
var notTooLargeContainers = function (dictOrd) {
    return function (map) {
        var containerCapacity = function (v) {
            return v.value0.capacity;
        };
        var smallestContainer = function (map1) {
            return Data_Array.head(Data_Array.sortWith(Data_Ratio.ordRatio(Data_Ord.ordInt)(Data_EuclideanRing.euclideanRingInt))(containerCapacity)(Data_Set.toUnfoldable(Data_Unfoldable.unfoldableArray)(Data_Map.keys(map1))));
        };
        var containedVolume = function (v) {
            if (v.allowedContainers.length === 0) {
                return Data_Semiring.zero(Data_Ratio.semiringRatio(Data_Ord.ordInt)(Data_EuclideanRing.euclideanRingInt));
            };
            return v.volume;
        };
        var containedsVolume = function (containeds) {
            return Data_Foldable.foldl(Data_Foldable.foldableArray)(function (vol) {
                return function (contained) {
                    return Data_Semiring.add(Data_Ratio.semiringRatio(Data_Ord.ordInt)(Data_EuclideanRing.euclideanRingInt))(vol)(containedVolume(contained));
                };
            })(Data_Semiring.zero(Data_Ratio.semiringRatio(Data_Ord.ordInt)(Data_EuclideanRing.euclideanRingInt)))(containeds);
        };
        return Data_Map_Internal.filterWithKey(Restaumatic_Menu_V2_Packaging.ordContainer(dictOrd))(function (v) {
            return function (containeds) {
                return Data_Ord.lessThanOrEq(Data_Ratio.ordRatio(Data_Ord.ordInt)(Data_EuclideanRing.euclideanRingInt))(v.value0.capacity)(containedsVolume(containeds)) || Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Packaging.eqContainer(dictOrd.Eq0())))(new Data_Maybe.Just(v))(smallestContainer(map));
            };
        })(map);
    };
};
var largestContainerWithContainedsFittingIn = function (dictOrd) {
    return function (map) {
        var v = Data_Array.head(Data_Array.sortBy(function (v1) {
            return function (v2) {
                return Data_Ord.compare(Data_Ratio.ordRatio(Data_Ord.ordInt)(Data_EuclideanRing.euclideanRingInt))(v2.value0.value0.capacity)(v1.value0.value0.capacity);
            };
        })(Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(map)));
        if (v instanceof Data_Maybe.Nothing) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Data_Maybe.Just) {
            var sortedDescContaineds = Data_Array.sortBy(function (v1) {
                return function (v2) {
                    return Data_Ord.compare(Data_Ratio.ordRatio(Data_Ord.ordInt)(Data_EuclideanRing.euclideanRingInt))(v2.volume)(v1.volume);
                };
            })(v.value0.value1);
            var v1 = Data_Foldable.foldl(Data_Foldable.foldableArray)(function (v2) {
                return function (v3) {
                    var newVol = Data_Semiring.add(Data_Ratio.semiringRatio(Data_Ord.ordInt)(Data_EuclideanRing.euclideanRingInt))(v2.value0)(v3.volume);
                    var $44 = Data_Ord.lessThanOrEq(Data_Ratio.ordRatio(Data_Ord.ordInt)(Data_EuclideanRing.euclideanRingInt))(newVol)(v.value0.value0.value0.capacity);
                    if ($44) {
                        return new Data_Tuple.Tuple(newVol, Data_Array.cons(v3)(v2.value1));
                    };
                    return v2;
                };
            })(new Data_Tuple.Tuple(Data_Semiring.zero(Data_Ratio.semiringRatio(Data_Ord.ordInt)(Data_EuclideanRing.euclideanRingInt)), [  ]))(v.value0.value1);
            return new Data_Maybe.Just(new Data_Tuple.Tuple(v.value0.value0, v1.value1));
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Packaging.MinNumberOfContainersHeuristicAlgo (line 42, column 47 - line 52, column 56): " + [ v.constructor.name ]);
    };
};
var containedsByEligibleContainers = function (dictOrd) {
    return function (containeds) {
        var eligibleContainers = function (v) {
            return Data_Array.filter(function (v1) {
                return Data_Ord.greaterThanOrEq(Data_Ratio.ordRatio(Data_Ord.ordInt)(Data_EuclideanRing.euclideanRingInt))(v1.value0.capacity)(v.volume);
            })(v.allowedContainers);
        };
        return Data_Foldable.foldl(Data_Foldable.foldableArray)(Data_Map_Internal.unionWith(Restaumatic_Menu_V2_Packaging.ordContainer(dictOrd))(Data_Semigroup.append(Data_Semigroup.semigroupArray)))(Data_Map_Internal.empty)(Control_Bind.bind(Control_Bind.bindArray)(containeds)(function (contained) {
            return Data_Functor.map(Data_Functor.functorArray)(Data_Function.flip(Data_Map_Internal.singleton)([ contained ]))(eligibleContainers(contained));
        }));
    };
};
var minNumberOfContainersHeuristic = function (dictOrd) {
    return function (containeds) {
        var v = largestContainerWithContainedsFittingIn(dictOrd)(containedsByEligibleContainers(dictOrd)(containeds));
        if (v instanceof Data_Maybe.Nothing) {
            return [  ];
        };
        if (v instanceof Data_Maybe.Just) {
            return Data_Array.cons(v.value0)(minNumberOfContainersHeuristic(dictOrd)(Data_Array.difference(Restaumatic_Menu_V2_Packaging.eqContained(dictOrd.Eq0()))(containeds)(v.value0.value1)));
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Packaging.MinNumberOfContainersHeuristicAlgo (line 15, column 45 - line 17, column 168): " + [ v.constructor.name ]);
    };
};
export {
    minNumberOfContainersHeuristic,
    containedsByEligibleContainers,
    notTooLargeContainers,
    largestContainerWithContainedsFittingIn
};
//# sourceMappingURL=index.js.map
